import { AsyncStatus } from '../../types/async-status';
import { ShuttleWithoutPassengersInfo } from './shuttle';
import { ShuttleDetails } from './shuttle-details';
import { ShuttleRoute } from './shuttle-route';
import { ShuttleSelectedSeat, ShuttleSelectedSeatWithoutSegmentInfo } from './shuttle-seat';

// ********************************************************************************
export type ShuttleController = {
  selectedShuttleRoute: ShuttleRoute | null;
  shuttleRoutes: {
    items: ShuttleRoute[];
    status: AsyncStatus;
  };
  shuttleDetails: ShuttleDetails | null;
  seats: ShuttleSelectedSeat[];

  selectSeats: (seats: ShuttleSelectedSeatWithoutSegmentInfo[]) => void;
  selectShuttleRoute: (shuttleRoute: ShuttleRoute) => void;

  buildPayload: (groupId: string) => ShuttleWithoutPassengersInfo | undefined;
  resetState: () => void;
  isComplete: boolean;
};

export const DEFAULT_SHUTTLE_CONTROLLER_VALUES: ShuttleController = {
  selectedShuttleRoute: null,
  shuttleRoutes: {
    items: [],
    status: 'idle',
  },
  shuttleDetails: null,
  seats: [],

  selectSeats: () => { },
  selectShuttleRoute: () => { },
  buildPayload: () => undefined,
  resetState: () => { },
  isComplete: false,
};
